import { IPrice, Price } from "@/entities";
import { IPriceRepository } from "./price.types";
import axios from "axios"

export class PriceAPIRepository implements IPriceRepository {
    async getPriceURL(branchCode: number): Promise<any | undefined> {
        const body = JSON.stringify({
            brcode: branchCode,
            'cprcode': [],
            'format': "json",
            'compression': "gzip",
        })
        const response = await axios.post('https://villa.kitchen/api/price/getallgz', body)
        if (response.status === 200) {
            return response.data.url
        } else {
            throw new Error(`Failed to load price url branch ${branchCode}`);
        }
    }

    async getPrice(branchCode: number): Promise<Map<number, Map<number, IPrice>>> {
        const url = await this.getPriceURL(branchCode)
        const response = await axios.get(url)
        if (response.status === 200) {
            const priceMap = new Map()
            const priceData = response?.data.data
            priceData.forEach((item: any) => {
                const cprcode = item[0]
                const price = item[2]
                const lastPrice = item[3]
                const pr = new Price({
                    cprcode: cprcode,
                    brcode: branchCode,
                    price: price,
                    lastPrice: lastPrice,
                })
                priceMap.set(pr.cprcode, pr)
            });
            const priceMapMap = new Map()
            priceMapMap.set(branchCode, priceMap)
            return priceMapMap
        } else {
            throw new Error(`Failed to load price url branch ${branchCode}`);
        }
    }
}